import { render, staticRenderFns } from "./UpdateNotifTemplatesModal.vue?vue&type=template&id=244db2f9"
import script from "./UpdateNotifTemplatesModal.vue?vue&type=script&lang=js"
export * from "./UpdateNotifTemplatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports